import { formalFormat } from 'amkit3-modules/utils/time'

import themeFactory from './themes/factory'

class TimeDisplay {
  constructor ($, $container) {
    this.$ = $
    this.$container = $container
    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()
    this.$time = $container.find(this.selector.controlBarTimeDisplayCurrent)
    this.$duration = $container.find(this.selector.controlBarTimeDisplayDuration)
  }
  setTime (value) {
    this.$time.text(formalFormat(value))
  }
  setDuration (value) {
    this.$duration.text(formalFormat(value))
  }
}

export default TimeDisplay
